import { et } from "../../../../date-fns/locale/et.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    et
  }
};